import React from 'react';
import { getOptimizedImageUrl, generateSrcSet } from '../utils/imageOptimization';

interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  priority?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  width = 800,
  height,
  className = '',
  objectFit = 'cover',
  priority = false,
  fetchPriority = 'auto',
}) => {
  // Generate optimized image URL
  const optimizedSrc = getOptimizedImageUrl(src, width, height);
  
  // Generate srcSet for responsive images
  const srcSet = generateSrcSet(src);
  
  // Determine sizes attribute based on width
  const sizes = width <= 640 ? '100vw' : width <= 1024 ? '50vw' : `${width}px`;
  
  // Style for object-fit
  const imgStyle: React.CSSProperties = {
    objectFit,
  };
  
  return (
    <img
      src={optimizedSrc}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={imgStyle}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
      fetchPriority={fetchPriority}
    />
  );
};